module.exports = __webpack_public_path__ + "static/media/Marker.6cb24adf.svg";